import React, { useContext, useEffect, useState, useTransition } from "react";
import "./Agendamento.scss";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import GlobalContext from "@context/GlobalContext";
import FullCalendario from "@components/fullcaledanrio/FullCalendario";
import Button from "@components/button/Button";
import EndPointServices from "@services/ApiServices";
import useLoading from "@hooks/useLoading";
import Grid from "@components/grid/Grid";
import mappingColumn from "@components/grid/mappingColumn";
import Modal from "@components/modal/Modal";
import Input from "@components/input/Input";
import MessageServices from "@services/MessageServices";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";
import UtilServices from "@services/UtilServices";

const Agendamento = () => {
  const [isPending, startTransition] = useTransition();
  useLoading(isPending);

  //Variaveis Padrões
  const [state, dispatch] = useContext(GlobalContext);
  const navigate = useNavigate();

  //calendario
  const [eventos, setEventos] = useState([]);
  const [clickEvento, setClickEvento] = useState([]);

  //Empresas
  const [empresa, setEmpresa] = useState([]);
  const [log, setLog] = useState([]);

  //modal
  const [showModal, setShowModal] = useState(false);
  //Second
  const [showSecond, setShowSecond] = useState(false);
  const [second, setSecond] = useState(0);

  useEffect(() => {
    handleConsultaAgendador();
  }, []);

  function handleConsultaAgendador() {
    startTransition(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
      };
      var retornoapi = await EndPointServices.Rpa_ConsultaAgendador(data);

      if (retornoapi?.Success) {
        let lstvalue = [];
        if (retornoapi?.BaseReturn?.LstClasse?.length > 0) {
          lstvalue = retornoapi?.BaseReturn?.LstClasse?.map((e, index) => ({
            title: e?.title,
            start: e?.Data,
            className: e?.status,
            extendedProps: {
              descricao: e?.status,
              id_agrupador: e?.id_agrupador,
              id_agendamento: e?.id_agendamento,
              id_compartilhado: e?.id_compartilhado,
              tarefadescricao: e?.tarefadescricao,
            },
          }));
        }
        setEventos(lstvalue);
      }
    });
  }
  function handleConsultaEmpresa(id_agendamento) {
    startTransition(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        id_agendamento: id_agendamento,
      };
      var retornoapi =
        await EndPointServices.Rpa_ConsultaAgendadorEmpresa(data);
      if (retornoapi?.Success) {
        setEmpresa(retornoapi.BaseReturn.LstClasse);
      }
    });
  }
  function handleConsultaLog(id_agendamento) {
    startTransition(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        id_agendamento: id_agendamento,
      };
      var retornoapi = await EndPointServices.Partilha_ConsultaLog(data);
      if (retornoapi?.Success) {
        setLog(retornoapi.BaseReturn.LstClasse);
      }
    });
  }
  function handleEventClick(e) {
    handleConsultaAgendador();
    handleConsultaEmpresa(e.event?.extendedProps?.id_agendamento);
    handleConsultaLog(e.event?.extendedProps?.id_agendamento);
    setClickEvento(e?.event);
  }
  function handleAtualizarAgendador(flgtipo) {
    startTransition(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        id_agendamento: clickEvento?.extendedProps?.id_agendamento,
        flgtipo: flgtipo,
      };
      var retornoapi = await EndPointServices.Rpa_AtualizarAgendador(data);

      if (retornoapi?.Success) {
        setShowModal(false);
        setClickEvento([]);
        if (flgtipo === 1) {
          MessageServices.ShowSuccess("Agendamento cancelado com sucesso!");
        } else if (flgtipo === 2) {
          MessageServices.ShowSuccess("Agendamento excluido com sucesso!");
        }
        handleConsultaAgendador();
        setEmpresa([]);
        setLog([]);
      }
    });
  }

  useEffect(() => {
    if (showSecond) {
      const intervalo = setInterval(() => {
        handleConsultaAgendador();
        setSecond(0);
      }, 5000); // 5000 ms = 5 segundos
      return () => clearInterval(intervalo);
    }
  }, [showSecond]);

  useEffect(() => {
    if (showSecond) {
      const contador = setInterval(() => {
        setSecond((prev) => prev + 1);
      }, 1000);

      return () => clearInterval(contador);
    }
  }, [showSecond]);

  return (
    <div className="agendamento row">
      <div className="col-12 row">
        <div
          className="novoagendamento col-md-6 col-7 justify-content-md-end justify-content-start"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <Button
            nome="Novo agendamento"
            icon="<i class='fa-solid fa-plus'></i>"
            theme="2"
            onClick={() => {
              navigate("/RPA/Cadastro/Agendamento");
            }}
          />
          <Button
            nome="Detalhes"
            theme="2"
            disabled={clickEvento.extendedProps?.id_agrupador ? false : true}
            onClick={() => {
              setShowModal(true);
            }}
          />
        </div>
        <div
          className="restart col-md-6 col-5"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            gap: "10px",
            marginBottom: "20px",
            padding: "0px",
          }}
        >
          <p>{UtilServices.maskFormatTime(second)}</p>
          <ButtonIcon
            Playpause
            onPlaypause={() => {
              setShowSecond(!showSecond);
              setSecond(0);
            }}
            titlePlaypause="Atualizar a cada 5 segundos a pagina."
            typePlaypause="submit"
          />
        </div>
      </div>
      <div className="col-md-6 col-12 novoagendamento">
        <FullCalendario events={eventos} handleEventClick={handleEventClick} />
      </div>
      <div className="col-md-6 col-12">
        <Grid
          dadosGrid={empresa}
          columns={mappingColumn.getRPA_EmpresasAgendadoresLog(empresa)}
          {...(empresa?.length > 0 && {
            pageVisible: true,
          })}
          exportExcel={false}
          columnSelector={false}
          searchPanel={false}
          Memo={false}
          iconTitle="<i class='fa-solid fa-users'></i>"
          title="Empresas"
          useLoading={isPending}
          pagingStaticSize="10"
        />
      </div>
      {UtilServices.hasPerfil(state.dadosusuario.perfil, 1) && (
        <div
          className="col-12"
          style={{ marginTop: "20px", marginBottom: "20px" }}
        >
          <Grid
            dadosGrid={log}
            columns={mappingColumn.getPartilha_log(log)}
            {...(log?.length > 0 && {
              pageVisible: true,
            })}
            Memo={false}
            iconTitle="<i class='fa-solid fa-screwdriver-wrench'></i>"
            title="Logs"
            useLoading={isPending}
            pagingStaticSize="5"
          />
        </div>
      )}
      <Modal
        showModal={showModal}
        setShowModal={setShowModal}
        title="Detalhes do agendamento"
        width="auto"
      >
        <div className="modal-input row container-fluid">
          <div className="col-md-3 col-12">
            <Input
              dflex={false}
              title="ID Tarefa"
              value={clickEvento?.extendedProps?.id_compartilhado}
              maxLength="5"
              type="document"
              disabled
              theme="2"
            />
          </div>
          <div className="col-md-3 col-12">
            <Input
              dflex={false}
              title="Tarefa"
              value={clickEvento?.extendedProps?.tarefadescricao}
              maxLength="5"
              type="document"
              disabled
              theme="2"
            />
          </div>
          <div className="col-md-3 col-12">
            <Input
              dflex={false}
              title="Data"
              value={clickEvento?.start?.toLocaleDateString()}
              maxLength="5"
              type="document"
              disabled
              theme="2"
            />
          </div>
          <div className="col-md-3 col-12">
            <Input
              dflex={false}
              title="Hora"
              value={clickEvento?.start?.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
              maxLength="5"
              type="document"
              disabled
              theme="2"
            />
          </div>
          <div
            className="col-12 justify-content-md-start justify-content-center"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              marginTop: "20px",
            }}
          >
            <Button
              nome="Cancelar"
              className="button-cancelar"
              theme="2"
              icon="<i class='fa-solid fa-ban'></i>"
              onClick={() => {
                handleAtualizarAgendador(1);
              }}
            />
            {UtilServices.hasPerfil(state.dadosusuario.perfil, 1) && (
              <Button
                nome="Excluir"
                className="button-excluir"
                icon="<i class='fa-solid fa-xmark'></i>"
                theme="2"
                onClick={() => {
                  handleAtualizarAgendador(2);
                }}
              />
            )}
            {UtilServices.hasPerfil(state.dadosusuario.perfil, 1) && (
              <Button
                nome="Reprocessar"
                className="button-reprocessar"
                icon="<i class='fa-solid fa-arrows-rotate'></i>"
                theme="2"
                onClick={() => {
                  handleAtualizarAgendador(3);
                }}
              />
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Agendamento;
